const CUR_SYMBOL: Record<string, string> = { INR: '₹', USD: '$' };

/**
 * A whole-unit amount with its currency symbol ("₹50,000"). One formatter, so the same fee reads
 * the same on the application page and on the Revenue tab.
 */
export const fmtMoney = (v: number | null | undefined, cur: string | null | undefined) =>
  `${CUR_SYMBOL[cur || ''] || (cur ? `${cur} ` : '')}${(typeof v === 'number' && Number.isFinite(v) ? v : 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;

/**
 * A chart-axis amount: "₹8L", "₹1.2Cr", "$12K". Indian grouping for INR, so an axis reads the way
 * the business talks; fmtMoney stays the exact figure for tooltips and tables.
 */
export const compactAmount = (v: number | null | undefined, cur: string | null | undefined) => {
  const n = typeof v === 'number' && Number.isFinite(v) ? v : 0;
  const locale = cur === 'USD' ? 'en-US' : 'en-IN';
  const body = n.toLocaleString(locale, { notation: 'compact', maximumFractionDigits: 1 });
  return `${CUR_SYMBOL[cur || ''] || (cur ? `${cur} ` : '')}${body}`;
};
